<template>
  <output-dialog
    :pages="pages"
    @print="onPrint"
    filename="eiaj.pdf"
    orientation="landscape"
    ref="printDlg"
    title="EIAJ検収伝票"
  >
    <template slot-scope="{page}">
      <div class="page">
        <div class="paper">
          <table class="layout-panel">
            <tr>
              <td class="left-panel" style="padding:10px;">
                <div class="header">
                  <div>検</div>
                  <div>収</div>
                  <div>伝</div>
                  <div>票</div>
                  <div>兼</div>
                  <div>請</div>
                  <div>求</div>
                  <div>書</div>
                </div>
              </td>
              <td class="center-panel" style="width:700px;padding:10px;">
                <table class="content" style="width:100%;">
                  <tr>
                    <td colspan="16">
                      <div class="key">発注者</div>
                      <div class="value">{{page.buName}}</div>
                    </td>
                    <td colspan="8">
                      <div class="key">納品キー番号</div>
                      <div class="value">{{page.poOrderNo}}+{{page.napin}}</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="10">
                      <div class="key">受渡場所名</div>
                      <div class="value">{{page.scWarehouseCode}}:{{page.scWarehouseName}}</div>
                    </td>
                    <td colspan="4">
                      <div class="key">購買担当</div>
                      <div class="value">{{page.buyerName}}</div>
                    </td>
                    <td colspan="10">
                      <div class="key">注文番号</div>
                      <div class="value">{{page.poOrderNo}}</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="12">
                      <div class="key">品名コード</div>
                      <div class="value">{{page.skuCode}}</div>
                    </td>
                    <td colspan="12">
                      <div class="key">品名</div>
                      <div class="value">{{page.skuName}}</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4">
                      <div class="key">出荷日</div>
                      <div class="value">{{page.etd}}</div>
                    </td>
                    <td colspan="12">
                      <div class="key">発注者備考</div>
                      <div class="value">{{page.remark}}</div>
                    </td>
                    <td colspan="4">
                      <div class="key">納期</div>
                      <div class="value">{{page.warehousingDate}}</div>
                    </td>
                    <td colspan="4">
                      <div class="key">納入予定日</div>
                      <div class="value">{{page.forecastDate}}</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="6">
                      <div class="key">カートンNo.</div>
                      <div class="value">{{ page.cartonFromTo }}</div>
                    </td>
                    <td colspan="6">
                      <div class="key">カートン数</div>
                      <div class="value">{{page.cartonQty}}</div>
                    </td>
                    <td colspan="3">
                      <div class="key">入り数</div>
                      <div class="value">{{page.perCarton}}</div>
                    </td>
                    <td colspan="6">
                      <div class="key">納入数量</div>
                      <div class="value">{{page.quantity}}</div>
                    </td>
                    <td colspan="3">
                      <div class="key">単位</div>
                      <div class="value">{{page.unit}}</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="12">
                      <div class="key">受注者用備考</div>
                      <div class="value">{{page.invoiceNo}}</div>
                      <div class="value">DO:{{page.doNo}}/コンテナ:{{page.containerNo}}</div>
                      <!-- <div class="value">ContainerNo</div>
                      <div class="value">{{page.containerNo}}</div>-->
                    </td>
                    <td colspan="1" style="width:40px;vertical-align: middle;text-align:center;">
                      <div>受入</div>
                      <div>数量</div>
                    </td>
                    <td colspan="7"></td>
                    <td colspan="4" rowspan="4">
                      <div style="text-align:center;">検査</div>
                      <div
                        style="height:100px;border:1px solid #333;border-left:0;border-right:0px;"
                      >&nbsp;</div>
                      <div style="text-align:center;">受入</div>
                      <div
                        style="height:100px;border:1px solid #333;border-left:0;border-right:0px;border-bottom:0px;"
                      >&nbsp;</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="12" rowspan="2" style="padding:0px;border:0px;">
                      <table class="data" style="width:100%;height:120px;">
                        <tr>
                          <td>
                            <div class="sub-title">免税諸掛外貨単価（A）</div>
                          </td>
                          <td>
                            <div class="sub-title">免税諸掛円貨単価</div>
                          </td>
                          <td>
                            <div class="sub-title">免税合計金額（外貨）</div>
                          </td>
                          <td>
                            <div class="sub-title">免税合計金額（円貨）</div>
                          </td>
                          <td>
                            <div class="sub-title">税抜請求額（円貨）</div>
                          </td>
                          <td>
                            <div class="sub-title">税抜請求額（外貨）</div>
                          </td>
                        </tr>
                        <tr>
                          <td>{{ page.freeTaxForeignUnitPrice | currency({symbol:page.foreignCurrencyName,fractionCount:2}) }}</td>
                          <td>{{ page.freeTaxJpyUnitPrice | currency({symbol:'￥',fractionCount:0}) }}</td>
                          <td>{{ page.freeTaxForeignTotal | currency({symbol:page.foreignCurrencyName,fractionCount:2}) }}</td>
                          <td>{{ page.freeTaxJpyTotal | currency({symbol:'￥',fractionCount:0}) }}</td>
                          <td>{{ page.jpyTotalBeforeTax | currency({symbol:'￥',fractionCount:0}) }}</td>
                          <td>{{ page.foreignTotalBeforeTax | currency({symbol:page.foreignCurrencyName,fractionCount:2}) }}</td>
                        </tr>
                        <tr>
                          <td>
                            <div class="sub-title">課税諸掛外貨単価(A)</div>
                          </td>
                          <td>
                            <div class="sub-title">課税諸掛円貨単価</div>
                          </td>
                          <td>
                            <div class="sub-title">課税合計金額（外貨）</div>
                          </td>
                          <td>
                            <div class="sub-title">課税合計金額（円貨）</div>
                          </td>
                          <td>
                            <div class="sub-title">税込請求額（円貨）</div>
                          </td>
                          <td>
                            <div class="sub-title">税込請求額（外貨）</div>
                          </td>
                        </tr>
                        <tr>
                          <td>{{page.taxForeignUnitPrice | currency({symbol:page.foreignCurrencyName,fractionCount:2}) }}</td>
                          <td>{{page.taxJpyUnitPrice | currency({symbol:'￥',fractionCount:0}) }}</td>
                          <td>{{page.taxForeignTotal | currency({symbol:page.foreignCurrencyName,fractionCount:2}) }}</td>
                          <td>{{page.taxJpyTotal | currency({symbol:'￥',fractionCount:0}) }}</td>
                          <td>{{page.jpyTotalAfterTax | currency({symbol:'￥',fractionCount:0}) }}</td>
                          <td>{{page.foreignTotalAfterTax | currency({symbol:page.foreignCurrencyName,fractionCount:2}) }}</td>
                        </tr>
                      </table>
                    </td>
                    <td colspan="1">
                      <div>検査合</div>
                      <div>計数量</div>
                    </td>
                    <td colspan="7"></td>
                  </tr>
                  <tr>
                    <td colspan="1">
                      <div>不良</div>
                      <div>数量</div>
                    </td>
                    <td colspan="7"></td>
                  </tr>
                  <tr>
                    <td colspan="12">
                      {{page.partnerName}}
                      円単価: {{page.unitPrice*page.unitPriceCurrencyRate | currency({symbol:'￥',fractionCount:0})}}
                      <br>
                      外貨単価: {{page.unitPrice | currency({symbol:page.unitPriceCurrencyName,fractionCount:4})}}
                      <br>
                      換算レート: {{page.unitPriceCurrencyRate | currency({symbol:'',fractionCount:2}) }}
                    </td>
                    <td colspan="1">検査区分</td>
                    <td colspan="7"></td>
                  </tr>
                  <tr>
                    <td colspan="8" style="border:0px;width:45%;">
                      上記諸掛費用を請求致します。
                      <br>シャープジャスダロジスティクス（株）
                      <br>
                      SJL納品書番号{{page.no}}
                      <br>
                      通関地：{{page.dischargePortName}}
                    </td>
                    <td colspan="5" style="width:10%;">
                      <!-- <div style="border-bottom:1px solid #333;text-align:center;">资材部</div> -->
                    </td>
                    <td colspan="11" style="border:0px;padding-left:20px;width:45%;">
                      {{page.poOrderNo}}+{{page.napin}}
                      <br>
                      <div class="barcode large">*{{page.poOrderNo}}00+{{page.napin}}*</div>
                    </td>
                  </tr>
                </table>
              </td>
              <td class="right-panel">
                <h1 style="text-align:center">検収伝票</h1>
                <div
                  style="margin-left:20px;"
                >（3N）3{{page.poOrderNo}}00+{{page.napin}} {{page.quantity}}</div>
                <div
                  class="barcode large"
                  style="margin-left:20px;"
                >*3N3{{page.poOrderNo}}00+{{page.napin}}{{page.quantity}}*</div>

                <div style="margin-left:20px;">（3N）4{{page.skuCode}}</div>
                <div class="barcode large" style="margin-left:20px;">*3N4{{page.skuCode}}*</div>

                <div style="margin-left:20px;">（3N）5{{page.skuCode}}</div>
                <div class="barcode large" style="margin-left:20px;">*3N5{{page.skuCode}}*</div>

                <div style="margin-left:20px;border:1px solid #333;height:60px;padding:2px;">
                  <div>受入数量</div>
                </div>
                <div style="margin-left:20px;text-align:right;">シャープジャスダロジスティクス（株）</div>
              </td>
            </tr>
            <tr>
              <td></td>
              <td colspan="2" style="padding-left:10px;">
                <h1>D/O情報</h1>
                <table>
                  <tr>
                    <td style="vertical-align: top;">
                      <table class="detail">
                        <tr>
                          <td style="width:100px;">D/O番号</td>
                          <td style="width:280px;">{{page.doNo}}-{{page.branchCode}}</td>
                        </tr>
                        <tr>
                          <td>海外取引先</td>
                          <td>{{page.partnerName}}</td>
                        </tr>
                        <tr>
                          <td>通関業者名</td>
                          <td>{{page.devanName}}</td>
                        </tr>
                        <tr>
                          <td>郵送方法名</td>
                          <td>{{page.transportModeName}}</td>
                        </tr>
                        <tr>
                          <td>B/L番号</td>
                          <td>{{page.blNo}}</td>
                        </tr>
                        <tr>
                          <td>MAWB</td>
                          <td>{{page.masterNo}}</td>
                        </tr>
                        <tr>
                          <td>HAWB</td>
                          <td>{{page.housingNo}}</td>
                        </tr>
                        <tr>
                          <td>インボイス番号</td>
                          <td>{{page.invoiceNo}}</td>
                        </tr>
                        <tr>
                          <td>積出港名</td>
                          <td>{{page.loadingPortName}}</td>
                        </tr>
                        <tr>
                          <td>到着港名</td>
                          <td>{{page.dischargePortName}}</td>
                        </tr>
                        <tr>
                          <td>荷渡港名</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>蔵置場所名</td>
                          <td>{{page.finallyWarehouseName}}</td>
                        </tr>
                        <tr>
                          <td>出港日</td>
                          <td>{{page.etd}}</td>
                        </tr>
                        <tr>
                          <td>入港日</td>
                          <td>{{page.eta}}</td>
                        </tr>
                        <tr>
                          <td>SJL営業担当</td>
                          <td>{{page.importSalesName}}</td>
                        </tr>
                        <tr>
                          <td>SJL通関担当</td>
                          <td></td>
                        </tr>
                      </table>
                    </td>
                    <td style="vertical-align: top;padding-left:20px;">
                      <table class="detail">
                        <tr>
                          <td style="width:100px;">得意先名</td>
                          <td style="width:280px;">{{page.buName}}</td>
                        </tr>
                        <tr>
                          <td>事業部名</td>
                          <td>{{page.departmentName}}</td>
                        </tr>
                        <tr>
                          <td>納入場所名</td>
                          <td>{{page.finallyWarehouseName}}</td>
                        </tr>
                        <tr>
                          <td>納期指定日</td>
                          <td>{{page.forecastDate}}</td>
                        </tr>
                        <tr>
                          <td>納入方法名</td>
                          <td></td>
                        </tr>
                        <tr>
                          <td>納品キー番号</td>
                          <td>{{page.poOrderNo}}+{{page.napin}}</td>
                        </tr>
                      </table>
                      <table class="detail" style="margin-top:15px;">
                        <tr>
                          <td style="width:100px;">SJL納品書番号</td>
                          <td style="width:280px;">{{page.no}}</td>
                        </tr>
                        <tr>
                          <td>伝票発行日</td>
                          <td>{{page.createDt}}</td>
                        </tr>
                        <tr>
                          <td>伝票発行時間</td>
                          <td>{{page.createTime}}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </template>
  </output-dialog>
</template>
<script>
export default {
  data() {
    return {
      pages: [{ charges: [] }],
      doId: null
    }
  },
  computed: {},
  methods: {
    pdfBuild() {
      return this.$download(`/delivery-orders/${this.doId}/batch-eiajs.pdf`)
    },
    onPrint() {
      this.$http.post(`/eiaj-history`, this.pages)
      this.$emit('refresh')
    },
    popup(pages, doId) {
      this.$refs.printDlg.show = true
      this.pages = pages
      this.doId = doId
    },

    hasTax(charge) {
      return charge.consumptionTaxRate > 0
    },

    //免税合計金額（外貨）
    freeTaxForeignTotal(page) {
      return page.charges
        .filter(i => i.isLocal)
        .filter(i => i.currencyCode != 'JPY')
        .filter(i => !this.hasTax(i))
        .map(i => i.subTotal)
        .reduce((x, y) => x + y, 0)
    },

    //課税合計金額（外貨）
    taxForeignTotal(page) {
      return page.charges
        .filter(i => i.isLocal)
        .filter(i => i.currencyCode != 'JPY')
        .filter(i => this.hasTax(i))
        .map(i => i.subTotal)
        .reduce((x, y) => x + y, 0)
    },
    //免時合計金額（円貨）,
    //免税円貨合计
    freeTaxJpyTotal(page) {
      return page.charges
        .filter(i => i.isLocal)
        .filter(i => i.currencyCode == 'JPY')
        .filter(i => !this.hasTax(i))
        .map(i => i.jpySubTotal)
        .reduce((x, y) => x + y, 0)
    },

    //免時合計金額（円貨）,
    //課税円貨合计
    taxJpyTotal(page) {
      return page.charges
        .filter(i => i.isLocal)
        .filter(i => i.currencyCode == 'JPY')
        .filter(i => this.hasTax(i))
        .map(i => i.jpySubTotal)
        .reduce((x, y) => x + y, 0)
    },

    //国际段外货额
    foreignFreightTotal(page) {
      return page.charges
        .filter(i => !i.isLocal)
        .filter(i => i.currencyCode != 'JPY')
        .map(i => i.subTotal)
        .reduce((x, y) => x + y, 0)
    },

    //国际段外货额转jpy
    foreignFreightTotalToJpy(page) {
      return page.charges
        .filter(i => !i.isLocal)
        .filter(i => i.currencyCode != 'JPY')
        .map(i => i.jpySubTotal)
        .reduce((x, y) => x + y, 0)
    },

    foreignFreightExchangeRate(page) {
      let arr = page.charges
        .filter(i => !i.isLocal)
        .filter(i => i.currencyCode != 'JPY')
        .map(i => i.currencyRate)
      if (arr != null && arr.length > 0) {
        return arr[0]
      }
      return 0
    },

    cartonNo(page) {
      let cartonNumber = ''
      if (page && page.cartonNumber && page.cartonNumber.length > 0) {
        for (var i = 0; i < page.cartonNumber.length; i++) {
          cartonNumber += page.cartonNumber[i]
          if (i % 2 == 0 && page.cartonNumber[i + 1] != null) {
            cartonNumber += '~'
          }
        }
      }
      return cartonNumber
    }
  }
}
</script>

<style scoped>
.page {
  padding: 30px 30px;
  height: 700px;
}
.paper {
  transform: scale(0.6);
  transform-origin: 0% 0%;
}
.header {
  margin: 0 auto;
  font-size: 24px;
  font-weight: bold;
  border: 2px solid #333;
  padding: 5px;
  width: 35px;
}
table {
  border-collapse: collapse;
}

table.layout-panel {
  width: 1550px;
}
table.content td {
  border: 1px solid #333;
  vertical-align: top;
  font-size: 12px;
  padding: 2px;
}
table.data {
  table-layout: fixed;
  border-collapse: collapse;
  width: 100%;
  border: 0px;
}
table.data div.sub-title {
  transform: scale(0.8);
  transform-origin: 0%;
}
table.data td {
  font-size: 12px;
  width: 100px;
  border: solid 1px #000;
  padding: 2px;
}

table.detail td {
  border: 1px solid #333;
  padding: 2px;
}

.barcode {
  font-family: barcode1;
}
.barcode.large {
  font-size: 60px;
  line-height: 80px;
}
</style>